import React from 'react';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
} from '@mui/material';

import type { AttendContactAbsenceJson } from '@/types/domain/attendContact/entities/attendContactAbsenceEntity';

import DialogTitle from '@/components/DialogTitle';
import DialogTransition from '@/components/DialogTransition';
import AbsenceInfo from '@/domain/attendContact/component/AbsenceInfo';

/**
 * 入力
 */
export type DetailAbsenceInput = {
  /** データ */
  data: AttendContactAbsenceJson | undefined,
  /** 閉じる */
  close: () => void,
}

const DetailAbsence: React.FC<DetailAbsenceInput> = ({ data, close }) => (
  <Dialog
    open={data !== undefined}
    onClose={() => close()}
    fullScreen
    TransitionComponent={DialogTransition}
  >
    <DialogTitle title="欠席連絡" />
    <DialogContent>
      {data && <AbsenceInfo data={data} />}
    </DialogContent>
    <DialogActions>
      <Button variant="contained" onClick={() => close()} color="primary">
        閉じる
      </Button>
    </DialogActions>
  </Dialog>
);

export default DetailAbsence;
